import {
  FINISH_LOADING_BY_ID,
  FINISH_LOADING_BY_SERVICE,
  FINISH_LOADING_BY_SIDEBAR,
  NO_LINKED_INCIDENT,
  RESET,
  START_LOADING_BY_ID,
  START_LOADING_BY_SERVICE,
  START_LOADING_BY_SIDEBAR,
  WAITING_FOR_INITIALIZATION,
} from './actions';

const init = {
  incident: undefined,
  loading: false,
  error: null,
  incidentAccountDomain: undefined,

  bySidebarInfo: {
    incident: undefined,
    error: undefined,
    loading: false,
  },

  byId: {
    incident: undefined,
    error: null,
    loading: false,
  },

  byService: {
    incident: undefined,
    error: null,
    loading: false,
  }
};

function applyAction(state, name, error, incident, loading) {
  state = {
    ...state,
    incidentAccountDomain: undefined,
    [name]: { error, incident, loading }
  };

  const all = [state.byId, state.bySidebarInfo, state.byService];
  state.loading = all.some(i => i.loading);
  state.incident = all.map(i => i.incident).find(i => i);
  state.error =
    !state.loading
    && !state.incident
    && all.map(i => i.error).find(i => i);

  if (state.incident) {
    const url = state.incident.html_url || '';
    const [domain] = url
      .replace(/https?:\/\//, '')
      .split('.');

    state.incidentAccountDomain = domain;
  }

  return state;
}

const reducer = (state = init, action) => {
  const { type, error, incident } = action;

  switch (type) {
    case RESET:
      return init;
    case WAITING_FOR_INITIALIZATION:
      return {
        ...state,
        loading: true
      };
    case NO_LINKED_INCIDENT: {
      return {
        ...state,
        loading: false
      };
    }
    case START_LOADING_BY_ID:
      return applyAction(state, 'byId', error, incident, true);
    case START_LOADING_BY_SIDEBAR:
      return applyAction(state, 'bySidebarInfo', error, incident, true);
    case START_LOADING_BY_SERVICE:
      return applyAction(state, 'byService', error, incident, true);
    case FINISH_LOADING_BY_ID:
      return applyAction(state, 'byId', error, incident, false);
    case FINISH_LOADING_BY_SIDEBAR:
      return applyAction(state, 'bySidebarInfo', error, incident, false);
    case FINISH_LOADING_BY_SERVICE:
      return applyAction(state, 'byService', error, incident, false);

    default:
      return state;
  }
};

export default reducer;
